import { get } from 'lodash';
import { mapPaymentTypeToCapability } from './utils';

export const getPaymentTypeCapability = (state) =>
	get(state, 'capabilities.user.capabilities', [])
		.filter(({ enabled }) => enabled === true)
		.reduce(
			(returnObj, cap) => ({
				...returnObj,
				[cap.capability]: cap.enabled,
			}),
			{}
		);

export const calcPaymentTypeCapable = (state, paymentType) => {
	const paymentCapability = mapPaymentTypeToCapability(paymentType);
	return !!getPaymentTypeCapability(state)[paymentCapability];
};
